import { useContext, useEffect, useState } from 'react';
import { createMessageTemplate, fetchMessageTemplates } from '../../../Service/restapi/messageService';
import { LoadingAnimation } from '../../../Service/ResourceAdapter';
import MessageTemplateCreate from './MessageTemplateCreate';
import MessageTemplateCustomList from './MessageTemplateCustomList';
import MessageTemplateListItem from './MessageTemplateListItem';
import PanePaper from '../../../Molecules/PanePaper';
import { useModalState } from '../../../Molecules/Dialogs';
import { useNavigate } from 'react-router-dom';
import MessageTemplateNameModal from '../../../Organismns/Settings/MessageTemplates/MessageTemplateNameModal';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { RoutingS } from '../../../Service/RoutingS';
import { MixpanelS } from '../../../Service/MixpanelS';
import { ConstantS } from '../../../Service/ConstantS';

const MessageTemplateList = () => {
  const [messageTemplates, setMessageTemplates] = useState(undefined);
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { show, toggle } = useModalState(false);
  const navigate = useNavigate();

  function create(templateName) {
    createMessageTemplate('CUSTOM', templateName).then((resp) => {
      if (resp.ok) {
        MixpanelS.track(ConstantS.TrackingEvents.EmailTemplateCreated);
        navigate(`/settings/template/message/custom/${templateName}`);
      }
    });
  }

  useEffect(() => {
    RoutingS.changeTitle('Email-Vorlagen');
    fetchMessageTemplates().then((resp) => {
      if (resp.ok) {
        resp.json().then((templates) => {
          const sortedTemplates = [];
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'AVAILABLE'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'UNAVAILABLE'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'OFFER'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'FOLLOW_UP'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'CONFIRM'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'SEND_CONTRACT'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'PREPAYMENT_RECEIVED'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'LASTCHECK'));
          sortedTemplates.push(templates.find((tpl) => tpl.messageType === 'INVOICE'));

          setMessageTemplates(sortedTemplates);
        });
      }
    });
  }, []);

  const styles = {
    actions: {
      marginBottom: 5,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    list: {
      backgroundColor: 'white',
      borderRadius: 5,
      paddingTop: 5,
      paddingBottom: 5,
    },
    itemContainer: {
      marginBottom: 5,
    },
    container: {},
  };

  const items = [];
  if (!messageTemplates) {
    return <LoadingAnimation />;
  }
  messageTemplates.forEach((value, index) => {
    if (!value) {
      console.error('some messageTemplate is missing, value is null', { value });
    } else {
      items.push(<MessageTemplateListItem key={index} messageTemplate={value} />);
    }
  });

  return (
    <div style={{ maxWidth: 500 }}>
      <MessageTemplateNameModal show={show} toggle={toggle} finish={create} />
      <PanePaper
        title="message.templates"
        tooltip="help.settings.message.templates.pane"
        rightSection={
          <BookitupAddIcon
            onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.MULTIPLE_EMAIL_TEMPLATE, toggle)}
          />
        }
      >
        <div style={styles.list}>
          {items}
          <MessageTemplateCustomList />
        </div>
      </PanePaper>
    </div>
  );
};

export default MessageTemplateList;
